import { Link } from "@/components/common/Link";
const products = [{
  title: "HSS",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hss_product.png",
  link: "/HSSStructuralProductsPage"
}, {
  title: "Viga IPR",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_product.png",
  link: "#"
}, {
  title: "Rejilla Irving",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/rejilla_irving_product.png",
  link: "#"
}];
export default function ProductsHero() {
  return <section id="products-hero" className="w-full bg-background">
      {}
      <div className="relative flex min-h-[300px] w-full items-center justify-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_bg.png)] bg-cover bg-center md:min-h-[400px]">
        <div className="absolute inset-0 bg-black/50"></div>
        <h1 className="font-default relative z-10 text-4xl font-bold tracking-wider text-white uppercase md:text-5xl lg:text-6xl">
          ESTRUCTURALES
        </h1>
      </div>

      {}
      <div className="container mx-auto px-4 py-12 md:px-6 md:py-16 lg:py-20">
        {}
        <div className="mx-auto max-w-6xl mb-12 md:mb-16">
          <p className="text-foreground/80 text-base leading-relaxed md:text-lg">
            Se utilizan en la fabricación de estructuras metálicas para
            construcciones industriales, señalamientos, invernaderos, entre
            otras. Son elementos que forman la parte resistente de una
            construcción. El sistema estructural en acero se basa en un marco o
            esqueleto de cualquier estructura cuyos componentes en su mayoría
            son columnas y vigas de acero, estos elementos nos ayudan para
            soportar el suelo, techo y las paredes de un edificio. Los perfiles
            se nombran en forma abreviada usando su altura o peralte y su peso
            por unidad de longitud.
          </p>
        </div>

        {}
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 md:gap-12">
          {products.map((product, i) => <div data-index={i} key={i} className="group flex flex-col">
              <Link to={product.link} className="block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                <div className="border-border/60 bg-background border p-2 transition-colors duration-300 group-hover:border-primary/50">
                  <div className="relative aspect-square w-full overflow-hidden bg-muted">
                    <img src={product.image} data-wvc-srcset={`${product.image}-wvc-srcset`} data-wvc-sizes={`${product.image}-wvc-sizes`} alt={`Producto ${product.title}`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  </div>
                </div>
                <h3 className="font-default text-foreground mt-6 text-center text-xl font-medium md:text-2xl">
                  {product.title}
                </h3>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}